"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//
// Stripe
//
const react_stripe_js_1 = require("@stripe/react-stripe-js");
//
// components
//
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const paymentMethodCopy_1 = require("copy/paymentMethodCopy");
const PaymentMethodForm = () => {
    const stripe = (0, react_stripe_js_1.useStripe)();
    const elements = (0, react_stripe_js_1.useElements)();
    // disable form until Stripe.js has loaded
    const loading = !stripe || !elements;
    const [stripeError, setStripeError] = (0, react_1.useState)(null);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            return;
        }
        /* eslint-disable camelcase */
        const result = yield stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href
            }
        });
        /* eslint-enable camelcase */
        if (result.error) {
            setStripeError(result.error);
            return;
        }
        // on success, Stripe redirects back to this page with a `redirect_status`
        // search param. This param is checked above to allow this component to
        // navigate correctly or re-render with error/validations.
    });
    const linkProps = {
        preface: paymentMethodCopy_1.paymentMethodCopy.linkPreface,
        href: paymentMethodCopy_1.paymentMethodCopy.linkHref,
        prompt: paymentMethodCopy_1.paymentMethodCopy.linkPrompt
    };
    // Merge Stripe Error and Payment Method Copy when an error occurs
    const apiError = (stripeError === null || stripeError === void 0 ? void 0 : stripeError.message)
        ? {
            message: stripeError.message,
            title: paymentMethodCopy_1.paymentMethodCopy.errorTitle,
            resolutionText: paymentMethodCopy_1.paymentMethodCopy.resolutionText,
            resolutionUrl: paymentMethodCopy_1.paymentMethodCopy.resolutionUrl
        }
        : undefined;
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'payment_method', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: apiError, contactLink: linkProps, cta: paymentMethodCopy_1.paymentMethodCopy.cta, header: paymentMethodCopy_1.paymentMethodCopy.header, inputs: [react_1.default.createElement(react_stripe_js_1.PaymentElement, { key: 'payment_element' })], loading: loading, onFormSubmit: handleSubmit }),
        react_1.default.createElement(HeroImage_1.default, { header: paymentMethodCopy_1.paymentMethodCopy.heroHeader, subheader: paymentMethodCopy_1.paymentMethodCopy.heroSubHeader })));
};
exports.default = PaymentMethodForm;
